import { useRequestStore } from '@/stores/requestStore';
import type { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';

export const applyAddRequestToStoreInterceptor = (axios: AxiosInstance) => {
  axios.interceptors.request.use(
    (requestConfig: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      const { addRequest } = useRequestStore();
      addRequest(requestConfig);

      return requestConfig;
    }
  );
};

export const applyRemoveRequestFromStoreInterceptor = (axios: AxiosInstance) => {
  axios.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => {
      const fullUrl
        = response.config.url
        + (response.config.params?.toString() ? `?${response.config.params.toString()}` : '');
      removeRequestFromUrl(fullUrl);

      return response;
    },
    (error) => {
      if (error.config?.url) {
        const fullUrl
          = error.config.url
          + (error.config.params?.toString() ? `?${error.config.params.toString()}` : '');
        removeRequestFromUrl(fullUrl);
      }

      return Promise.reject(error);
    }
  );
};

function removeRequestFromUrl(url?: string) {
  if (!url) {
    return;
  }
  const { removeRequest } = useRequestStore();
  removeRequest(url);
}
